export default {
  "content": "<path d=\"M13.5 12.5a1 1 0 00-1 1V20h2v-4.086l6.293 6.293 1.414-1.414-6.293-6.293H20v-2h-6.5zM1.793 3.207L8.086 9.5H4v2h6.5a1 1 0 001-1V4h-2v4.086L3.207 1.793 1.793 3.207z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};